// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2XJoP","options":"AnswerScale_options__1Jxvo","selected":"AnswerScale_selected__1l69M"};